import React from 'react';
import { ArrowRight, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { businessInfo } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tilefix-scheduler/artifacts/c05hbcds_IMG_1809.png";

const ContactCTA = () => {
  return (
    <section id="contact" className="section bg-[#152a42]">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo */}
          <img src={LOGO_URL} alt="Top Notch Tile LLC" className="h-32 mx-auto mb-8" />
          
          <span className="caption text-[#F7931E] mb-4 block">Get Started</span>
          <h2 className="heading-2 text-white mb-4">Ready to Transform Your Space?</h2>
          <p className="body-large text-[#c5d3e3] mb-8 max-w-2xl mx-auto">
            Fill out our detailed estimate form and we'll get back to you within 24–48 hours 
            to discuss your project and schedule an on-site consultation.
          </p>

          {/* CTA Button */}
          <Link to="/estimate" className="btn-primary text-lg px-8 py-4 inline-flex items-center gap-2">
            Request Free Estimate
            <ArrowRight size={20} />
          </Link>

          {/* Contact Info Grid */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-[#0d1f33] rounded-lg p-6 border border-[#F7931E]/20">
              <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mx-auto mb-4">
                <Phone size={24} className="text-[#F7931E]" />
              </div>
              <h3 className="text-white font-semibold mb-2">Call Us</h3>
              <a href={`tel:${businessInfo.phone.replace(/\D/g, '')}`} className="text-[#c5d3e3] hover:text-[#F7931E] transition-colors">
                {businessInfo.phone}
              </a>
            </div>

            <div className="bg-[#0d1f33] rounded-lg p-6 border border-[#F7931E]/20">
              <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mx-auto mb-4">
                <Mail size={24} className="text-[#F7931E]" />
              </div>
              <h3 className="text-white font-semibold mb-2">Email Us</h3>
              <a href={`mailto:${businessInfo.email}`} className="text-[#c5d3e3] hover:text-[#F7931E] transition-colors">
                {businessInfo.email}
              </a>
            </div>

            <div className="bg-[#0d1f33] rounded-lg p-6 border border-[#F7931E]/20">
              <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mx-auto mb-4">
                <MapPin size={24} className="text-[#F7931E]" />
              </div>
              <h3 className="text-white font-semibold mb-2">Service Area</h3>
              <p className="text-[#c5d3e3]">{businessInfo.serviceArea}</p>
            </div>
          </div>

          {/* Hours */}
          <div className="mt-8 flex items-center justify-center gap-2 text-[#F7931E]">
            <Clock size={18} />
            <span>Mon-Sat: 7AM - 6PM</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
